import { IAtlasObjectRef } from '@common/helpers/atlasUrls'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'atlasLinks'

export const [
  LIST_OBJECT_PREVIEWS_REQUEST,
  LIST_OBJECT_PREVIEWS_SUCCESS,
  LIST_OBJECT_PREVIEWS_FAILURE,
] = createRequestTypes(prefix, 'LIST_OBJECT_PREVIEWS')

export const listAtlasObjectPreviews = createAction((refs: IAtlasObjectRef[]) => ({
  type: [LIST_OBJECT_PREVIEWS_REQUEST, LIST_OBJECT_PREVIEWS_SUCCESS, LIST_OBJECT_PREVIEWS_FAILURE],
  promise: (api: IApi) => api.atlasLinks.listObjectPreviews(refs),
  params: { refs },
}))
